import { apiClient } from './client';
export interface FleetFieldContext { id: number; fullName: string; workerRole: number; businessName: string; isOwner: boolean; capabilities?: { crewTransport: boolean; shopDelivery: boolean } }
export interface FleetTaskProof { id: number; type: number; filePath: string; notes?: string; capturedOn: string; capturedBy?: string }
export const fleetFieldApi = {
  context: async () => (await apiClient.get<FleetFieldContext>('/booking/providers/field/context')).data,
  proofs: async (taskId: number) => (await apiClient.get<FleetTaskProof[]>(`/booking/providers/field/tasks/${taskId}/proofs`)).data,
  update: async (taskId: number, status: number, transport: boolean) => (await apiClient.post('/providers/dispatch/tasks/status', {
    taskId, ...(transport ? { newDriverStatus: status } : { newStatus: status }),
  })).data,
  capture: async (taskId: number, filePath: string, notes: string, point?: GeolocationPosition) => (await apiClient.post('/providers/dispatch/tasks/proof', {
    taskId, type: 0, filePath, notes, latitude: point?.coords.latitude, longitude: point?.coords.longitude,
  })).data,
};
